import { DateConverter } from 'src/app/core/services/mapper/converters';
import * as moment from 'moment';

export class AccueilAnppProducteur {
    static readonly jsonMap = {
        idEntreprise: { key: 'idEntreprise' },
        raisonSociale: { key: 'raisonSociale', optional: true, default: '' },
        email: { key: 'email', optional: true, default: '' },
        telephone: { key: 'telephone', optional: true, default: '' },
        groupement: { key: 'groupement', optional: true, default: '' },
        dateDeclarationRecolte: { key: 'dateDeclarationRecolte', converter: new DateConverter(), optional: true },
        dateDeclarationStock: { key: 'dateDeclarationStock', converter: new DateConverter(), optional: true },
        dateDeclarationrEcoulement: { key: 'dateDeclarationrEcoulement', converter: new DateConverter(), optional: true },
        dateModificationInventaireVerger: { key: 'dateModificationInventaireVerger', converter: new DateConverter(), optional: true }
    };

    public idEntreprise: number;
    public raisonSociale: string;
    public email: string;
    public telephone: string;
    public groupement: string;
    dateDeclarationRecolte: moment.Moment;
    dateDeclarationStock: moment.Moment;
    dateDeclarationrEcoulement: moment.Moment;
    dateModificationInventaireVerger: moment.Moment;
}
